import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Search, Building2, User, CalendarDays } from "lucide-react";
import { api, fmtDT } from "@/lib/api";

export const GlobalSearch = () => {
  const [q, setQ] = useState("");
  const [res, setRes] = useState(null);
  const nav = useNavigate();
  const ref = useRef();

  useEffect(() => {
    if (q.trim().length < 2) { setRes(null); return; }
    const t = setTimeout(() => api.get("/search", { params: { q } }).then((r) => setRes(r.data)), 250);
    return () => clearTimeout(t);
  }, [q]);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setRes(null); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const go = (path) => { setQ(""); setRes(null); nav(path); };
  const empty = res && !res.leads.length && !res.users.length && !res.meetings.length;

  return (
    <div className="relative w-full max-w-md" ref={ref}>
      <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      <input data-testid="global-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search leads, contacts, phone, meetings…"
        className="h-9 w-full rounded-full border border-input bg-slate-50 pl-9 pr-3 text-sm outline-none transition-colors focus:border-primary focus:bg-white" />
      {res && (
        <div data-testid="global-search-results" className="absolute left-0 right-0 top-11 z-50 max-h-96 overflow-y-auto rounded-lg border bg-white shadow-xl">
          {empty && <p className="p-4 text-sm text-muted-foreground">No results</p>}
          {res.leads.map((l) => (
            <button key={l.id} data-testid={`search-result-lead-${l.id}`} onClick={() => go(`/leads/${l.id}`)} className="flex w-full items-center gap-3 px-4 py-2.5 text-left hover:bg-slate-50">
              <Building2 className="h-4 w-4 text-primary" />
              <span className="flex-1"><span className="block text-sm font-semibold">{l.company}</span><span className="text-xs text-muted-foreground">{l.contact_person} · {l.vertical} · {l.stage}</span></span>
            </button>
          ))}
          {res.meetings.map((m) => (
            <button key={m.id} onClick={() => go(`/leads/${m.lead_id}`)} className="flex w-full items-center gap-3 px-4 py-2.5 text-left hover:bg-slate-50">
              <CalendarDays className="h-4 w-4 text-blue-500" />
              <span><span className="block text-sm font-semibold">{m.title}</span><span className="text-xs text-muted-foreground">{fmtDT(m.scheduled_at)}</span></span>
            </button>
          ))}
          {res.users.map((u) => (
            <button key={u.id} onClick={() => go(`/team`)} className="flex w-full items-center gap-3 px-4 py-2.5 text-left hover:bg-slate-50">
              <User className="h-4 w-4 text-emerald-500" />
              <span><span className="block text-sm font-semibold">{u.name}</span><span className="text-xs text-muted-foreground">{u.email} · {u.role}</span></span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
